<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      fill="#E0625C"
    />
    <path
      d="M15.0711 8.47581L8.4714 15.0755C8.21105 15.3358 8.21105 15.7579 8.4714 16.0183C8.73175 16.2786 9.15386 16.2786 9.41421 16.0183L16.0139 9.41862C16.2742 9.15827 16.2742 8.73616 16.0139 8.47581C15.7535 8.21546 15.3314 8.21546 15.0711 8.47581Z"
      fill="#E0625C"
    />
    <path
      d="M16.0144 15.0711L9.41476 8.4714C9.15441 8.21105 8.7323 8.21105 8.47195 8.4714C8.21161 8.73175 8.21161 9.15386 8.47195 9.41421L15.0716 16.0139C15.332 16.2742 15.7541 16.2742 16.0144 16.0139C16.2748 15.7535 16.2748 15.3314 16.0144 15.0711Z"
      fill="#E0625C"
    />
  </svg>
</template>
